import elapsedTimeInWords from "./elapsedTimeInWords";
import _ from "underts";

const formatDateForDisplay = (date: Date, now: Date) => {
  return elapsedTimeInWords((now.getTime() - date.getTime()) / 1000);
};

const getSeenByNames = (
  msg: { seen_by: string[] },
  allUsers: { id: string; messagename: string }[],
  currentUserId: string
) => {
  const seenIdFiltered = msg.seen_by.filter((id) => id !== currentUserId);
  const usersFiltered = allUsers.filter((user) =>
    seenIdFiltered.includes(user.id)
  );
  return _.compact(
    usersFiltered.map((u) => ("messagename" in u ? u.messagename : undefined))
  );
};

const isNotSeenByMe = (
  msg: {
    author_doctor_id: string | null;
    author_secretary_id: string | null;
    seen_by: string[];
  },
  currentUserId: string
) => {
  if (
    msg.author_doctor_id === currentUserId ||
    msg.author_secretary_id === currentUserId
  ) {
    return false;
  }
  if (!msg.seen_by.includes(currentUserId)) {
    return true;
  }
  return false;
};

const getPosterName = (
  msg: { author_doctor_id: string | null; author_secretary_id: string | null },
  allUsers: { id: string; messagename: string }[]
) => {
  const poster = allUsers.find(
    (user) =>
      user.id === msg.author_doctor_id || user.id === msg.author_secretary_id
  );
  return (poster && poster.messagename) || "Cadendar";
};

const formatMessageForDisplay = <
  T extends {
    author_doctor_id: string | null;
    author_secretary_id: string | null;
    seen_by: string[];
    timestamp: Date;
  }
>(
  msg: T,
  now: Date,
  allUsers: { id: string; messagename: string }[],
  currentUserId: string
) => {
  return {
    ...msg,
    notSeenByMe: isNotSeenByMe(msg, currentUserId),
    posterName: getPosterName(msg, allUsers),
    seenByNames: getSeenByNames(msg, allUsers, currentUserId),
    displayAge: formatDateForDisplay(msg.timestamp, now),
  };
};

export default formatMessageForDisplay;
